"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Shift = /** @class */ (function () {
    function Shift() {
    }
    return Shift;
}());
exports.Shift = Shift;
